import graphql__6081d853b1a8d74d9fdf from "./__generated__/AuthenticationModal_viewer.graphql.js";
import graphql__c0b1d466f83bb7828a6f from "./__generated__/AuthenticationModal_authenticationConfig.graphql.js";import { useState } from "react";
import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";

import Modal from "../Modals/Modal";
import { AuthenticationCollapsibleFormsContextProvider } from "./AuthenticationCollapsibleFormsContext";
import { useFormatMessage } from "../Intl/Context";
import AuthenticationFranceConnectForm from "./AuthenticationFranceConnectForm";
import AuthenticationModalMethods from "./AuthenticationModalMethods";

const AuthenticationModal = props => {
  const [selectedAuthOption, setSelectedAuthOption] = useState(null);

  const viewer = useFragment(AuthenticationModal_viewer, props.viewer);
  const { isUser } = viewer;

  const authenticationConfig = useFragment(
    AuthenticationModal_authenticationConfig,
    props.authenticationConfig
  );
  const { allowUserAccountCreation, authenticationModal } = authenticationConfig;
  const {
    displayed,
    displayFranceConnect,
    displayOpenid,
    displaySaml,
    displaySignIn,
    displaySignUp
  } = authenticationModal;

  const { onClose, authorizeAnonymousUserAuth, onSignIn, authenticationAdditionalProps } =
    props;

  const t = useFormatMessage();
  const title = t(intlMessages.title);

  const displayAnonymousUserAuthentication = !!authorizeAnonymousUserAuth;
  const displayAuthenticationMethods =
    displayAnonymousUserAuthentication ||
    displayOpenid ||
    displaySaml ||
    displaySignIn ||
    displaySignUp;
  const displayFranceConnectSeparator =
    displayFranceConnect && displayAuthenticationMethods;

  const hasLargeModal = allowUserAccountCreation;
  const modalClassName = hasLargeModal ? "" : "modal-sm";

  if ((!displayed && !authorizeAnonymousUserAuth) || isUser) {
    return null;
  }

  return (
    <Modal
      isOpen={true}
      shouldCloseOnOverlayClick={true}
      onRequestClose={onClose}
      breadcrumbs={[{ title }]}
      title={title}
      className={modalClassName}
      overlayClassName="authentication-modal-overlay"
    >
      <AuthenticationCollapsibleFormsContextProvider
        selectedAuthOption={selectedAuthOption}
        setSelectedAuthOption={setSelectedAuthOption}
      >
        <div className="authentication-home">
          {/* Display the FranceConnect container and separator as per the FranceConnect specs */}
          {displayFranceConnect && (
            <div className="authentication-panel box box-shadow-lg padding-md">
              <div className="authentication-france-connect-section">
                {authenticationConfig.franceConnectAuthServices?.[0] && (
                  <AuthenticationFranceConnectForm
                    franceConnectAuth={authenticationConfig.franceConnectAuthServices[0]}
                  />
                )}
              </div>

              {displayFranceConnectSeparator && (
                <div className="authentication-separator">
                  <span>{t(intlMessages.orSeparator)}</span>
                </div>
              )}

              {displayAuthenticationMethods && (
                <div className="authentication-methods">
                  <AuthenticationModalMethods
                    authenticationConfig={authenticationConfig}
                    viewer={viewer}
                    authorizeAnonymousUserAuth={authorizeAnonymousUserAuth}
                    onSignIn={onSignIn}
                    authenticationAdditionalProps={authenticationAdditionalProps}
                  />
                </div>
              )}
            </div>
          )}

          {/* Display the plain authentication methods container if no FranceConnect service exists  */}
          {!displayFranceConnect && (
            <AuthenticationModalMethods
              authenticationConfig={authenticationConfig}
              viewer={viewer}
              authorizeAnonymousUserAuth={authorizeAnonymousUserAuth}
              onSignIn={onSignIn}
              authenticationAdditionalProps={authenticationAdditionalProps}
            />
          )}
        </div>
      </AuthenticationCollapsibleFormsContextProvider>
    </Modal>
  );
};

const AuthenticationModal_viewer = graphql__6081d853b1a8d74d9fdf;

const AuthenticationModal_authenticationConfig = graphql__c0b1d466f83bb7828a6f;

export default AuthenticationModal;

const intlMessages = defineMessages({
  title: {
    id: "authentication.title",
    defaultMessage: "Identifiez-vous"
  },
  orSeparator: {
    id: "authentication.separator.or",
    defaultMessage: "ou"
  }
});
